import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div className="h-dvh max-h-dvh overflow-hidden">
      <Outlet />
    </div>
  );
}
